module.exports = __webpack_public_path__ + "static/media/hitbtc.abe9c410.png";